var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104.219,
    height: 104.219,
    rx: 9.8016,
    fill: "#231671",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6747 28.7051H31.2722C30.5913 28.7051 29.9384 28.9755 29.457 29.457C28.9755 29.9384 28.7051 30.5913 28.7051 31.2722V46.6747C28.7051 47.3555 28.9755 48.0085 29.457 48.4899C29.9384 48.9713 30.5913 49.2418 31.2722 49.2418H46.6747C47.3555 49.2418 48.0085 48.9713 48.4899 48.4899C48.9713 48.0085 49.2418 47.3555 49.2418 46.6747V31.2722C49.2418 30.5913 48.9713 29.9384 48.4899 29.457C48.0085 28.9755 47.3555 28.7051 46.6747 28.7051ZM72.3455 54.3759H56.943C56.2622 54.3759 55.6092 54.6464 55.1278 55.1278C54.6464 55.6092 54.3759 56.2622 54.3759 56.943V72.3455C54.3759 73.0264 54.6464 73.6793 55.1278 74.1607C55.6092 74.6422 56.2622 74.9126 56.943 74.9126H72.3455C73.0264 74.9126 73.6793 74.6422 74.1607 74.1607C74.6422 73.6793 74.9126 73.0264 74.9126 72.3455V56.943C74.9126 56.2622 74.6422 55.6092 74.1607 55.1278C73.6793 54.6464 73.0264 54.3759 72.3455 54.3759ZM64.6443 28.7051C58.9813 28.7051 54.3759 33.3104 54.3759 38.9734C54.3759 44.6364 58.9813 49.2418 64.6443 49.2418C70.3073 49.2418 74.9126 44.6364 74.9126 38.9734C74.9126 33.3104 70.3073 28.7051 64.6443 28.7051ZM38.9734 54.3759C33.3104 54.3759 28.7051 58.9813 28.7051 64.6443C28.7051 70.3073 33.3104 74.9126 38.9734 74.9126C44.6364 74.9126 49.2418 70.3073 49.2418 64.6443C49.2418 58.9813 44.6364 54.3759 38.9734 54.3759Z",
    fill: "#231671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpIcon);
export default __webpack_public_path__ + "static/media/follow_up_icon.0ef5631a5f698e84d66894485dd7c26e.svg";
export { ForwardRef as ReactComponent };